 const config = {
    domain: 'https://wwwawsuat.ebiz.verizon.com',
    // domain: 'https://wwwawssit.ebiz.verizon.com',
}

export default config;